import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import applicationReducer from './reducers/applicationReducer';
import { reducer as formReducer } from 'redux-form';

const reducer = combineReducers({
    routing: routerReducer,
    application: applicationReducer,
    form: formReducer

});

export default reducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js